<template>
  <div>
    <dialog-loading loadingText="Deletando..." v-if="deleting"></dialog-loading>
    <v-card flat>
      <v-card-text >
        <v-divider class="my-2 mb-4"></v-divider>
        <FilterData
          with_client_portfolios
          with_text_search
          :loading_block="loading.bonus"
          class="mt-2"
          @doneFilter="handleDoneFilter"
        />
        <v-data-table
          :loading="loading.bonus"
          :items="bonus_payments"
          :headers="headers"
          :search="tableSearch"
        >
          <template v-slot:item.attributes.value="{item}">
            {{ Number(item.attributes.value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>
          <template v-slot:item.solution="{item}">
            {{ modality_name }}
          </template>
          <template v-slot:item.attributes.created_at="{item}">
            {{ $moment(item.attributes.created_at).format('DD/MM/YYYY') }}
          </template>
          <template v-slot:item.actions="{item}">
            <div class="d-flex align-center">
              <v-tooltip bottom v-if="isDirector()">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="deletePayment(item)" v-bind="attrs" v-on="on" x-small outlined fab class="ml-1 mr-2" color="error">
                    <v-icon>mdi-trash-can</v-icon>
                  </v-btn>
                </template>
                <span>Excluir pagamento</span>
              </v-tooltip>
              <DialogOrdersPayedBySource :payment_id="item.attributes.payment_id"></DialogOrdersPayedBySource>
              <DownloadPaymentResume :payment_id="item.attributes.payment_id"></DownloadPaymentResume>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Api from "@/api/index";

export default {
  name: "BonusPayments",
  components:{
    DialogOrdersPayedBySource: () => import("@/_backoffice/_financial/components/payment/shared/DialogOrdersPayedBySource.vue"),
    DownloadPaymentResume: () => import("@/_backoffice/_financial/components/payment/shared/DownloadPaymentResume.vue"),
    FilterData: () => import("@/components/shared/FilterData.vue"),
  },
  data() {
    return {
      local_filter: {},
      deleting: false,
      bonus_payments: [],
      headers: [
        { text: 'Data do pagamento', value: 'attributes.created_at' },
        { text: 'Comentário', value: 'attributes.comment' },
        { text: 'Valor', value: 'attributes.value' },
        { text: 'Cliente', value: 'attributes.client_name' },
        { text: 'Galpão', value: 'solution' },
        { text: 'Ações', value: 'actions' },
      ],
      loading: {
        bonus: false,
      }
    };
  },
  computed:{
    tableSearch() {
      return (this.local_filter && this.local_filter.query) ? String(this.local_filter.query) : ''
    },
  },
  methods: {
    getData(){
      this.getBonusPayments()
    },
    handleDoneFilter(filter){
      this.local_filter = { ...filter }
      this.getBonusPayments()
    },
    deletePayment(item){
      this.swallConfirmation({
          title: 'Deseja EXCLUIR o pagamento?',
          icon: 'warning',
        }).then( confirmed =>{
          if (confirmed ) {
            this.deleting = true
            let payment_id = item.attributes.payment_id
            Api.Payment.delete(payment_id).then(res => {
              this.successDeleted()
            }).catch(err => {
              this.errorUpdated()
            }).finally(()=>{
              this.deleting = false
              this.getData()
            })
          }
        })     
    },
    getBonusPayments(){
      this.loading.bonus = true
      let params = {
          ...this.local_filter,
          only_with_bonus: true,
          modality_ids: [this.activeModalityId],
        }
      this.$emit("filters", params)
      Api.Bonus.index(params).then(res => res.data).then(res => {
        this.bonus_payments = [ ...res.data ]
      }).finally(() => {
        this.loading.bonus = false
      })
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    activeModalityId() {
      this.getData()
    },
  },
};
</script>